"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    RATING: 'rating',
    RATING_COMMENT: 'rating_comment',
    ABSENCE_REASON: 'absence_reason',
};
//# sourceMappingURL=feedbackQuestionType.js.map